/**
 * @description 与基座交互的操作函数全部放在这里导出
 * 使用方法：
 *   1. 在main.ts
 *      import wujie form './utils/wujie'
 *       const app = createApp(import.meta.env.MODE === 'development' ? AppElementPlus : AppOld)
 *      app.use(wujie)
 *
 */

import type { App, Plugin } from 'vue'

/** 模块内全局对象，用来接收基座需要合并的全局变量，建议优先使用此变量进行与基座的交互 */
const _global = {} as Window
/** 全局变量window */
const global_window = window
/** 当前环境是否处于基座下（是否能调用window.$wujie）,每次需要使用$wujie都需要检查此项 */
let canUseWujie = false

/** 设置基座tab标题 */
export const setTabTitle = (title: string) => {
  if (!canUseWujie) {
    return
  }
  // 必须等到tab切换后才能设置title
  setTimeout(() => {
    _global.$wujie.props?.set_TabTitle(title)
  }, 10)
}

/**
 * 初始化与基座的数据，包括路由，全局变量代理等
 */
const install = (app: App) => {
  if (!global_window.$wujie) {
    return
  }
  // 设置可用
  canUseWujie = true
  const { bus, location, props, shadowRoot } = global_window.$wujie
  _global.$wujie = global_window.$wujie
  if (props) {
    // 合并全局变量（是否有必要？）
    Object.assign(global_window, props.__MIX_TO_WINDOW__ || {})
    Object.assign(_global, props.__MIX_TO_WINDOW__ || {})
    // 调用基座函数，初始化子应用（实际上也是添加全局属性）
    typeof props.init_BaseApi__Wujie === 'function' && props.init_BaseApi__Wujie(global_window)
    typeof props.init_BaseApi__Wujie === 'function' && props.init_BaseApi__Wujie(_global)
  }
}
/**
 * @description 与wujie以及基座的初始化
 * 用法：
 * import wujie form './utils/wujie'
 * import App from './App.vue'
 * ...
 * const app = createApp(App)
 * app.use(wujie) // 以防后续可能用到基座的功能，建议最先条用此语句
 *
 * @returns VUE3 插件
 */
export const wujie: Plugin = {
  install
}
